export default __webpack_public_path__ + "static/media/guernica.6f5969c6.jpg";